function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import { useConstCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { ListItem } from '../../util/ListItem';
import { TreeMapState, useCascader, useCascaderItem } from '../../../hooks/cascader';
export function CascaderItem(props) {
  var id = props.id,
      children = props.children,
      className = props.className,
      onClick = props.onClick,
      style = props.style;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      previousClickTime = _useState2[0],
      setPreviousClickTime = _useState2[1];

  var info = useCascaderItem(id);
  var cascader = useCascader();
  var onClickCallback = useRefCallback(onClick);
  var handlerChange = useCallback(function () {
    var id = info.id,
        state = info.state;

    if (state === TreeMapState.SELECTED) {
      cascader.setItemState(id, TreeMapState.UNSELECTED);
      return;
    }

    if (state === TreeMapState.PARTIAL) {
      cascader.setItemState(id, TreeMapState.UNSELECTED);
      return;
    }

    cascader.setItemState(id, TreeMapState.SELECTED);
  }, [info]);
  var handlerClose = useConstCallback(function () {
    cascader.setVisible(false);
  });
  var handleItemClick = useCallback(function (e) {
    var disabled = info.disabled,
        readonly = info.readonly,
        isLeaf = info.isLeaf,
        selectable = info.selectable;

    if (!disabled && !readonly && selectable) {
      if (isLeaf) {
        handlerChange();
        handlerClose();
      } else if (!cascader.multiple && cascader.independent) {
        var currentClickTime = Date.now();

        if (currentClickTime - previousClickTime < 300) {
          handlerClose();
        } else {
          handlerChange();
          setPreviousClickTime(currentClickTime);
        }
      }
    }

    cascader.setActiveId(info.id);
    onClickCallback(e);
  }, [info]);
  return React.createElement(ListItem, {
    prefixCls: "cascader-item",
    className: className,
    checkable: info.selectable && cascader.multiple,
    disabled: info.disabled,
    readonly: info.readonly,
    state: info.state,
    onCheckboxChange: handlerChange,
    onClick: handleItemClick,
    style: style
  }, typeof children === 'function' ? children(info) : children);
}